import Breadcrumbs from "./Breadcrumbs";
import { useTheme } from "../Theme";

export default function PageTitle({ title, breadcrumb = [] }) {
  const { darkMode, toggleModes } = useTheme();

  const pageTitle = darkMode 
  ? "text-white "  
  : "text-black ";

  return (
    <div className="page-title-wrapper w-full h-[173px] py-10">
      <div className="container-x mx-auto">
        <div className="mb-5">
          <Breadcrumbs paths={breadcrumb}/>
        </div>
        <div className="flex justify-center">
          <h1 className={`text-3xl font-semibold text-qblack ${pageTitle}`}>{title}</h1>
        </div>
      </div>
    </div>
  );
}
